import React from "react";
import { Link } from "react-router-dom";
import { Star, Sparkles, ArrowUpRightSquare } from "lucide-react";

const STORIES = [
  {
    name: "Marisol V.",
    role: "Beauty Store Partner",
    city: "Cebu",
    quote: "I made my first sale two days after activating my online store. No inventory, no shipping headaches — I just posted and shared. My kids now help me pack orders on weekends.",
    highlight: "First sale in 48 hours",
  },
  {
    name: "Rico A.",
    role: "Electronics Partner",
    city: "Metro Manila",
    quote: "The AI captions saved me hours a week. I focus on customer chats and reels; Zenith handles the rest. My best week so far paid better than my old office salary.",
    highlight: "Replaced office income",
  },
  {
    name: "Jenna P.",
    role: "Home & Living Partner",
    city: "Davao",
    quote: "What I love most: my customers are real people, not points on a dashboard. Zenith made me a real business owner — with real products in real homes.",
    highlight: "Real customers, real orders",
  },
  {
    name: "Diana L.",
    role: "Health & Wellness Partner",
    city: "Iloilo",
    quote: "Being a stay-at-home mom used to mean giving up income. Now I run my store from the sofa. Withdrawals hit my e-wallet within the day. It's not a side hustle anymore — it's my career.",
    highlight: "Full-time from home",
  },
  {
    name: "Kevin R.",
    role: "Fashion Partner",
    city: "Baguio",
    quote: "I built a team of 12 partners in three months. Not from cold DMs — from teaching what actually works. Zenith's training + AI tools are unmatched.",
    highlight: "Team of 12 in 3 months",
  },
  {
    name: "Aileen S.",
    role: "Executive Partner",
    city: "Bacolod",
    quote: "I upgraded to Executive after seeing my third month's numbers. The margin difference alone paid for the kit. My team gets deeper wholesale pricing and my customers get better prices.",
    highlight: "Upgraded to Executive",
  },
];

export default function SuccessStories() {
  return (
    <div className="space-y-10" data-testid="success-stories-page">
      <div>
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.28em] text-[#FBBF24] font-bold mb-3">
          <Sparkles size={12} /> Success Stories
        </div>
        <h1 className="font-display text-4xl md:text-5xl font-black tracking-tight max-w-3xl">
          Real partners.{" "}
          <span className="text-[#FBBF24]">Real customers.</span>{" "}
          Real growth.
        </h1>
        <p className="text-white/70 max-w-3xl mt-5 leading-relaxed">
          These are Zenith partners running modern online businesses today.
          Their stories are shared with permission and reflect their own experiences —
          your results will depend on your own sales activity.
        </p>
      </div>

      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {STORIES.map((s, i) => (
          <div key={s.name} className="glass-card p-6" data-testid={`success-story-${i}`}>
            <div className="flex items-center gap-1 text-[#FBBF24] mb-3">
              {[0, 1, 2, 3, 4].map((n) => (<Star key={n} size={13} fill="#FBBF24" />))}
            </div>
            <div className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.18em] font-bold bg-[#FBBF24]/10 border border-[#FBBF24]/30 text-[#FBBF24] px-2 py-1 rounded-full mb-3">
              {s.highlight}
            </div>
            <p className="text-sm text-white/80 leading-relaxed italic">&ldquo;{s.quote}&rdquo;</p>
            <div className="mt-5 pt-4 border-t border-white/10">
              <div className="font-display font-black">{s.name}</div>
              <div className="text-[11px] uppercase tracking-[0.2em] text-white/45 font-semibold">{s.role} · {s.city}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="glass-card gold-border p-8 text-center">
        <div className="text-[10px] uppercase tracking-[0.22em] text-[#FBBF24] font-bold mb-2">Your story next?</div>
        <div className="font-display text-2xl md:text-3xl font-black">Start your online business today.</div>
        <Link to="/register" className="btn-deploy mt-5 inline-flex items-center gap-2 px-8 py-3 rounded-md text-sm font-bold uppercase tracking-widest" data-testid="success-cta">
          <ArrowUpRightSquare size={16} /> Become a Partner
        </Link>
      </div>

      <p className="text-center text-[11px] uppercase tracking-[0.22em] text-white/40 pt-4">
        Testimonials reflect individual experiences · Results vary based on effort and sales activity
      </p>
    </div>
  );
}
